<template>
  <div class="flex wrap column gap-4">
  <div class="card">
    <h1>H1 H1 H1</h1>
    <h2>H2 H2 H2</h2>
    <h3>H3 H3 H3</h3>
    <h4>H4 H4 H4</h4>
    <h5>H5 H5 H5</h5>
    <h6>H6 H6 H6</h6>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

  </div>
  <div class="card pb-5">
    <h3>Button</h3>
    <div class="flex row wrap gap-2">
          <button v-for="color in colors" :key="color" :class="color">{{color}}</button>

    </div>

  </div></div>
</template>
<script>

export default {
  name: 'designSystem',
  path: '/designSystem',
  setup () {
    const colors = [
      'primary',
      'secondary',
      'accent', 'success', 'error', 'info', 'warning'
    ]
    return { colors }
  }

}
</script>
